export default __webpack_public_path__ + "static/media/provesional_restoration_lower_36_4@2x.2974cf70.png";